import { TableCard } from 'app/components'
import { ProfissionalDeSaudeListHeader } from './components/header/ProfissionalDeSaudeListHeader'
import { ListFiltersProvider } from './core/ListFiltersProvider'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponseProvider } from './core/QueryResponseProvider'
import { ProfissionalDeSaudeTable } from './table/ProfissionalDeSaudeTable'

const ProfissionalDeSaudeList = () => {
  return (
    <TableCard>
      <ProfissionalDeSaudeListHeader />
      <ProfissionalDeSaudeTable />
    </TableCard>
  )
}

export const ProfissionalDeSaudeListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListFiltersProvider>
        <ProfissionalDeSaudeList />
      </ListFiltersProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)
